var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrewRoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 8.25C6.75 9.90685 8.09315 11.25 9.75 11.25C11.4069 11.25 12.75 9.90685 12.75 8.25C12.75 6.59315 11.4069 5.25 9.75 5.25C8.09315 5.25 6.75 6.59315 6.75 8.25ZM14.25 11.25C14.25 12.4926 15.2574 13.5 16.5 13.5C17.7426 13.5 18.75 12.4926 18.75 11.25C18.75 10.0074 17.7426 9 16.5 9C15.2574 9 14.25 10.0074 14.25 11.25Z",
    fill: "#B0B7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73751 12.75C6.19643 12.75 3.29119 14.5699 3.00049 18.1494C2.98465 18.3444 3.35753 18.75 3.54563 18.75H15.935C16.4984 18.75 16.5072 18.2966 16.4984 18.15C16.2787 14.4699 13.3284 12.75 9.73751 12.75ZM20.5921 18.75H17.7C17.7 17.0618 17.1422 15.5039 16.2009 14.2505C18.7558 14.2784 20.842 15.5701 20.999 18.3C21.0053 18.41 20.999 18.75 20.5921 18.75Z",
    fill: "#B0B7C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrewRoster);
export default __webpack_public_path__ + "static/media/crew-roster.b3816bd64453539e329b3d536139bdd1.svg";
export { ForwardRef as ReactComponent };